const fonts = {
  size: {
    xsmall: "14px",
    small: "18px",
    medium: "20px",
    large: "24px",
    xlarge: "32px",
  },
  weight: { light: "400", regular: "400", normal: "400", bold: "600" },
  letterSpacing: { small: "0", medium: "0", large: "0.02em" },
  lineHeight: { small: "1.4", medium: "1.75", large: "2" },
}

const makeTheme = (mode, background, surface, text, muted, accent, border) => ({
  mode,
  surface,
  border,
  muted,
  accentInk: "#ffffff",
  colors: {
    text: { primary: { 400: muted, 500: text }, secondary: { 500: accent } },
    background: { primary: { 300: surface, 400: background, 500: background } },
    accent: {
      primary: {
        50: `${accent}12`,
        100: `${accent}24`,
        200: accent,
        300: accent,
        400: accent,
        500: accent,
      },
    },
  },
  fonts,
})

const darkTheme = makeTheme(
  "dark",
  "#111113",
  "#1d1d1f",
  "#f5f5f7",
  "#a1a1a6",
  "#70b7ff",
  "#343438"
)
const lightTheme = makeTheme(
  "light",
  "#ffffff",
  "#f5f5f7",
  "#1d1d1f",
  "#6e6e73",
  "#0066cc",
  "#e5e5e9"
)

export { darkTheme, lightTheme }
